import { useNodeConnections } from '@xyflow/react';
import { LLMPrimitive } from './primitive';
import { LLMTransform } from './transform';

export type LLMNodeProps = {
  type: string;
  data: {
    generated?: {
      text: string;
    };
    model?: string;
    systemPrompt?: string;
    updatedAt?: string;

    // Generated content from connected nodes
    text?: string;
  };
  id: string;
};

export const LLMNode = (props: LLMNodeProps) => {
  const connections = useNodeConnections({
    id: props.id,
    handleType: 'target',
  });

  const Component = connections.length ? LLMTransform : LLMPrimitive;

  return <Component {...props} title="LLM" />;
};
